import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function ValuationItemLoader({
  showFooter = false,
}: {
  showFooter?: boolean;
}) {
  return (
    <div className="tab-content-item ">
      <div className="flex">
        <div className="flex flex-1 flex-col gap-1.5x md:gap-2x">
          <div className="md:hidden">
            <Skeleton width={140} height={18} borderRadius={8} />
          </div>
          <div className="flex items-center gap-3x">
            <Skeleton width={160} height={24} borderRadius={8} />
          </div>
          <Skeleton width={180} height={28} borderRadius={8} />
        </div>

        <div className="flex w-full items-center justify-between gap-2x md:w-auto md:flex-col md:items-end">
          <div className="hidden md:inline-block">
            <Skeleton width={40} height={12} borderRadius={8} />
          </div>
          {!showFooter && <Skeleton width={120} height={40} borderRadius={8} />}
        </div>
      </div>
      {showFooter && (
        <div className="w-full pt-3x border-t border-gray mt-3x md:mt-0">
          <div className="flex flex-col md:flex-row w-full h-full justify-between gap-2x">
            <div className="flex gap-3x md:gap-7x">
              <div className="flex flex-col gap-1.5x">
                <Skeleton width={120} height={16} borderRadius={8} />
                <Skeleton width={80} height={20} borderRadius={8} />
              </div>
              <div className="flex flex-col gap-1.5x">
                <Skeleton width={120} height={16} borderRadius={8} />
                <Skeleton width={100} height={20} borderRadius={8} />
              </div>
            </div>
            <Skeleton width={140} height={40} borderRadius={8} />
          </div>
        </div>
      )}
    </div>
  );
}
